export const ROLE_KEYS = [
  'admin',
  'supervisor',
  'hod',
  'leader',
  'developer',
  'community_member',
  'client',
  'pr',
  'marketing',
  'graphics',
  'resource_manager',
];

export const ROLE_METADATA = {
  admin: {
    name: 'Admin',
    description: 'System administrators with full platform access.',
    permissions: [],
  },
  supervisor: {
    name: 'Supervisor',
    description: 'Academic or project supervisors overseeing delivery workflows.',
    permissions: [],
  },
  hod: {
    name: 'Head of Department',
    description: 'Department leadership with review and oversight permissions.',
    permissions: [],
  },
  leader: {
    name: 'Project Leader',
    description: 'Leads project execution, assignments, and coordination.',
    permissions: [],
  },
  developer: {
    name: 'Developer',
    description: 'Contributors working on project tasks and deliverables.',
    permissions: [],
  },
  community_member: {
    name: 'Community Member',
    description: 'Community participants contributing to project activities.',
    permissions: [],
  },
  client: {
    name: 'Client',
    description: 'External clients linked to projects and approvals.',
    permissions: [],
  },
  pr: {
    name: 'PR Team',
    description: 'Public relations users coordinating communication work.',
    permissions: [],
  },
  marketing: {
    name: 'Marketing Team',
    description: 'Users responsible for campaign and promotion work.',
    permissions: [],
  },
  graphics: {
    name: 'Graphics Team',
    description: 'Team responsible for creating and managing design assets.',
    permissions: [
      'graphics.view',
      'graphics.upload',
      'graphics.edit',
      'graphics.delete',
      'graphics.approve',
      'projects.view',
      'resources.view',
    ],
  },
  resource_manager: {
    name: 'Resource Manager',
    description: 'Users responsible for managing resource availability and bookings.',
    permissions: [],
  },
};

export const ROLE_OPTIONS = ROLE_KEYS.map((key) => ({
  value: key,
  label: ROLE_METADATA[key]?.name || key,
}));

export default ROLE_METADATA;
